import { create } from 'zustand'
import { persist, createJSONStorage }
    from 'zustand/middleware'

const useAppStore = create(
    persist(
        (set, get) => ({
            userType: [],
            userName: '',
            userEmail: '',
            userId: '',
            token: '',
            selectedPost: '',
            updateSelectedPost: (selectedPost) =>
                set({ selectedPost: selectedPost }),
            updateToken: (token) =>
                set({ token: token }),
            updateUserId: (userId) =>
                set({ userId: userId }),
            updateUserEmail: (userEmail) =>
                set({ userEmail: userEmail }),
            updateUserName: (userName) =>
                set({ userName: userName }),
            updateUserType: (userType) =>
                set({ userType: userType }),
        }),
        {
            name: 'codingmstr-seller-storage', 
        },
    ),
)

export default useAppStore;